import { useContext, useState, useEffect } from "react";
import { MainContext } from "../../../../MainContext";
import { request } from "../../../../request";
import { Button, Modal, Select } from "flowbite-react";
import CreatableSelect from "react-select/creatable";
import Swal from "sweetalert2";
import MoneyInput from "../../Inputs/MoneyInput";

const CurrencyInputs = ({ setValue, index, remove, selected_currencies, texts }) => {
    const [values, setValues] = useState({
        currency_name: "",
        avg: "",
        value: "",
    });

    const { all_currencies, updateAllCurrencies } = useContext(MainContext);
    const handleChange = (e) => {
        setValues({
            ...values,
            [e.name]: e.value,
        });
    };

    useEffect(() => {
        setValue({
            currency_name: values.currency_name,
            avg: values.currency_name !== "AMD" ? parseInt(values.avg) : 1,
            value: parseInt(values.value),
        });
    }, [values]);

    // Add New Value
    const addNewCurrencyType = async (type) => {
        console.log(type);
        try {
            await request.post("/currency/", {
                name: type,
            });
            updateAllCurrencies();
            handleChange({
                value: type,
                name: "currency_name",
            });
        } catch (error) {
            console.log(error);
        }
    };

    const options = all_currencies
        .filter((e) => !selected_currencies.some((sc) => sc.currency_name === e))
        .map((option) => ({
            value: option,
            label: option,
        }));

    const createableSelectStyles = {
        control: (base) => ({
            ...base,
            borderColor: "gray",
            borderRadius: "0.375rem",
            padding: "0.375rem",
            boxShadow: "none",
            "&:hover": {
                borderColor: "blue",
            },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "blue" : state.isFocused ? "lightgray" : "white",
            color: state.isSelected ? "white" : "black",
            "&:hover": {
                backgroundColor: "lightblue",
            },
        }),
        menu: (base) => ({
            ...base,
            marginTop: 0,
            borderRadius: "0.375rem",
        }),
        placeholder: (base) => ({
            ...base,
            color: "gray",
            fontSize: "0.875rem",
        }),
    };

    return (
        <div className="mb-4">
            <div className="lg:flex sm:relative items-center justify-between mb-3 ">
                <p className="text-[#fff] text-2xl" style={{ marginTop: "21px" }}>
                    {index + 1}.
                </p>
                <div className="">
                    <label className="flex flex-col min-w-40 flex-1" style={{ marginTop: "21px" }}>
                        <CreatableSelect
                            isClearable
                            options={options}
                            onChange={(e) =>
                                handleChange({
                                    value: e?.label,
                                    name: "currency_name",
                                })
                            }
                            value={values.currency_name ? { label: values.currency_name } : null}
                            onCreateOption={(e) => addNewCurrencyType(e)}
                            styles={createableSelectStyles}
                            placeholder={texts.account.currency}
                            name="currency-name"
                        />
                    </label>
                </div>

                <div className="">
                    <label className="">
                        <MoneyInput
                            value={values.value}
                            onChange={(e) => handleChange({ name: "value", value: e })}
                            className="form-input mt-2 sm:mt-0 flex w-full h-50 min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
                            placeholder="Currency value"
                            required
                            uppervalue={texts.account.value}
                        />
                    </label>
                </div>
                <div className="">
                    <label className="">
                        <MoneyInput
                            value={values.currency_name !== "AMD" ? values.avg : 1}
                            onChange={(e) => handleChange({ name: "avg", value: e })}
                            className="form-input mt-2 sm:mt-0 flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-xl text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[16px] text-base font-normal leading-normal"
                            placeholder="Enter Avg"
                            required
                            disabled={values.currency_name === "AMD"}
                            uppervalue={texts.account.average}
                        />
                    </label>
                </div>
                <button
                    className=" flex min-w-[84px] mt-2 sm:mt-0 max-w-[480px] w-20 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-10 px-4 bg-[#333] text-[#ff0000] text-sm font-bold leading-normal tracking-[0.015em]"
                    onClick={remove}
                    disabled={selected_currencies.length < 2}
                    style={{ marginTop: "21px" }}
                >
                    {texts.account.remove}
                </button>
            </div>
        </div>
    );
};

export default CurrencyInputs;
